import React from "react";

import ApiImage from "@common/assets/images/icon-api.png";
import Button from "@common/components/Button/Button";
import { ModalProps } from "@common/components/Modal/Modal";
import { ModalHeaderProps } from "@common/components/Modal/ModalHeader/ModalHeader";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";

import * as Styled from "./ModalBody.styles";

interface Props {
  seePlans: () => void;
  Modal: React.ForwardRefExoticComponent<ModalProps & ModalHeaderProps & React.RefAttributes<unknown>>;
  internalProps?: ModalProps;
}

export default function RestApiPlanLimitModalBody({ seePlans, Modal, internalProps }: Props) {
  const handleSeePlans = (e?: React.MouseEvent<Element, MouseEvent>) => {
    e?.preventDefault();
    seePlans();
  };

  return (
    <Modal
      {...internalProps}
      heading="REST API isn't on your plan"
      buttonElement={
        <Button
          type="button"
          size="small"
          onClick={(e) => handleSeePlans(e)}
        >
          See plans
        </Button>
      }
    >
      <Flex $column>
        <img
          style={{ alignSelf: "center", marginBottom: "2.4rem", height: "5.4rem" }}
          src={ApiImage}
          alt="API"
        />
        <Styled.Subtitle>
          Your current plan doesn&apos;t include REST API access. Upgrade to the Organization plan to create REST API
          keys.
        </Styled.Subtitle>
      </Flex>
    </Modal>
  );
}
